import instance from '@/http/http'

const resolveNotificationApiBase = () => {
  if (typeof window !== 'undefined') {
    const runtimeOverride = window.__NOTIFICATION_API_BASE__
      || (window.localStorage && window.localStorage.getItem && window.localStorage.getItem('NOTIFICATION_API_BASE'))

    if (runtimeOverride) {
      return runtimeOverride
    }
  }

  return process.env.VUE_APP_NOTIFICATION_API_BASE || '/knowledge-api'
}

const notificationRequest = (config = {}) => {
  return instance({
    baseURL: resolveNotificationApiBase(),
    ...config
  })
}

/**
 * 通知相关API接口
 */

// 获取通知列表
export function getNotificationList(params = {}) {
  return notificationRequest({
    url: '/notification/list',
    method: 'get',
    params: {
      page: 1,
      size: 20,
      ...params
    }
  })
}

// 获取待办列表
export function getTodoList(params = {}) {
  return notificationRequest({
    url: '/notification/todo',
    method: 'get',
    params: {
      page: 1,
      size: 20,
      ...params
    }
  })
}

// 标记通知为已读
export function markAsRead(notificationId) {
  return notificationRequest({
    url: `/notification/${notificationId}/read`,
    method: 'put'
  })
}

// 批量标记为已读
export function markAllAsRead() {
  return notificationRequest({
    url: '/notification/mark-all-read',
    method: 'put'
  })
}

// 处理待办事项
export function handleTodo(todoId, action, data = {}) {
  return notificationRequest({
    url: `/notification/todo/${todoId}/handle`,
    method: 'post',
    data: { action, ...data }
  })
}

// 获取未读通知数量
export function getUnreadCount() {
  return notificationRequest({
    url: '/notification/unread-count',
    method: 'get'
  })
}

// 删除通知
export function deleteNotification(notificationId) {
  return notificationRequest({
    url: `/notification/${notificationId}`,
    method: 'delete'
  })
}

// 获取通知详情
export function getNotificationDetail(notificationId) {
  return notificationRequest({
    url: `/notification/${notificationId}`,
    method: 'get'
  })
}

// 获取待办详情
export function getTodoDetail(todoId) {
  return notificationRequest({
    url: `/notification/todo/${todoId}`,
    method: 'get'
  })
}

// 批量删除通知
export function batchDeleteNotifications(notificationIds) {
  return notificationRequest({
    url: '/notification/batch-delete',
    method: 'post',
    data: { notificationIds }
  })
}

// 设置通知偏好
export function setNotificationPreferences(preferences) {
  return notificationRequest({
    url: '/notification/preferences',
    method: 'put',
    data: preferences
  })
}

// 获取通知偏好
export function getNotificationPreferences() {
  return notificationRequest({
    url: '/notification/preferences',
    method: 'get'
  })
}

// 搜索通知
export function searchNotifications(keyword, params = {}) {
  return notificationRequest({
    url: '/notification/search',
    method: 'get',
    params: {
      keyword,
      ...params
    }
  })
}

// 获取通知统计信息
export function getNotificationStats() {
  return notificationRequest({
    url: '/notification/stats',
    method: 'get'
  })
}
